import React from 'react';

const CosmicLogo = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        {/* Ethereal cosmic gradient - more visible but elegant */}
        <linearGradient id="cosmicGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#7FFFD4', stopOpacity: 0.55 }} />
          <stop offset="33%" style={{ stopColor: '#8A2BE2', stopOpacity: 0.45 }} />
          <stop offset="66%" style={{ stopColor: '#FFD700', stopOpacity: 0.50 }} />
          <stop offset="100%" style={{ stopColor: '#7FFFD4', stopOpacity: 0.55 }} />
        </linearGradient>

        {/* Elegant glow effect */}
        <radialGradient id="glowGradient" cx="50%" cy="50%" r="50%">
          <stop offset="0%" style={{ stopColor: '#7FFFD4', stopOpacity: 0.12 }} />
          <stop offset="100%" style={{ stopColor: '#7FFFD4', stopOpacity: 0 }} />
        </radialGradient>

        {/* Subtle blur for ethereal effect */}
        <filter id="etherealBlur">
          <feGaussianBlur in="SourceGraphic" stdDeviation="0.5" />
        </filter>
      </defs>

      {/* Inner glow */}
      <circle cx="50" cy="50" r="45" fill="url(#glowGradient)" />

      {/* Ethereal reflection circles - more visible but elegant */}
      <g filter="url(#etherealBlur)">
        <circle 
          cx="50" 
          cy="50" 
          r="38" 
          fill="none" 
          stroke="url(#cosmicGradient)" 
          strokeWidth="1.2"
          opacity="0.6"
        />
        <circle 
          cx="50" 
          cy="50" 
          r="40" 
          fill="none" 
          stroke="url(#cosmicGradient)" 
          strokeWidth="1"
          opacity="0.45"
        />
        <circle 
          cx="50" 
          cy="50" 
          r="36" 
          fill="none" 
          stroke="url(#cosmicGradient)" 
          strokeWidth="0.9"
          opacity="0.35"
        />
        <circle 
          cx="50" 
          cy="50" 
          r="42" 
          fill="none" 
          stroke="url(#cosmicGradient)" 
          strokeWidth="0.7"
          opacity="0.25"
        />
      </g>

      {/* Decorative small stars */}
      <circle cx="20" cy="25" r="1" fill="#FFD700" opacity="0.6" />
      <circle cx="75" cy="30" r="1.5" fill="#7FFFD4" opacity="0.5" />
      <circle cx="80" cy="70" r="1" fill="#9D4EDD" opacity="0.4" />

      {/* Text "E·I" - PERFECTLY CENTERED with precise calculation */}
      {/* Centre del viewBox: 50,50. Font size 38. Ajust vertical precís: +15 */}
      <text
        x="50"
        y="65"
        textAnchor="middle"
        fontSize="38"
        fontWeight="100"
        fontFamily="Arial, sans-serif"
        letterSpacing="3"
      >
        <tspan fill="#B0E8E0" filter="url(#softGlow)">E</tspan>
        <tspan fill="#D0D0D0">·</tspan>
        <tspan fill="#C0C0C0">I</tspan>
      </text>
      
      {/* Soft glow for letters */}
      <defs>
        <filter id="softGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
    </svg>
  );
};

export default CosmicLogo;
